// API related constants
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1';
export const API_TIMEOUT = Number(import.meta.env.VITE_API_TIMEOUT) || 30000;

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
  },
  USERS: {
    BASE: '/users',
    BORROWERS: '/users/borrowers',
    BY_ID: (id: string) => `/users/${id}`,
    BY_EMAIL: '/users/by-email',
    REGISTER: '/users/register',
    ASSIGNED_SALESPERSON: '/users/me/assigned-salesperson',
  },
  APPLICATIONS: {
    BASE: '/applications',
    BY_ID: (id: string) => `/applications/${id}`,
    SUBMIT: (id: string) => `/applications/${id}/submit`,
    COMPANY: (id: string) => `/applications/${id}/company`,
    PROJECT: (id: string) => `/applications/${id}/project`,
    OWNERS: (id: string) => `/applications/${id}/owners`,
    OWNER_SENSITIVE: (applicationId: string, ownerId: string) =>
      `/applications/${applicationId}/owners/${ownerId}/sensitive`,
    DISCLOSURES: (id: string) => `/applications/${id}/disclosures`,
    BUILDER_EXPERIENCE: (id: string) => `/applications/${id}/builder-experience`,
    CREDIT_REFERENCES: (id: string) => `/applications/${id}/credit-references`,
  },
  STORAGE: {
    UPLOAD_URL: '/storage/upload-url',
    VERIFY_UPLOAD: '/storage/verify-upload',
    DOWNLOAD_URL: '/storage/download-url',
    DELETE: '/storage',
    DELETE_BY_APPLICATION: '/storage/by-application',
  },
  EMAIL: {
    STARTED: '/email/started',
    REMINDER: '/email/reminder',
    SUBMITTED: '/email/submitted',
  },
  CONSENTS: {
    SMS: '/consents/sms',
  },
  SETTINGS: {
    BASE: '/settings',
    BY_KEY: (key: string) => `/settings/${key}`,
    PUBLIC: '/settings/public',
  },
  SALESPERSONS: {
    BASE: '/salespersons',
    PUBLIC: '/salespersons/public',
    BY_ID: (id: string) => `/salespersons/${id}`,
  },
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;
